function fallbackBasePath(baseUrl) {
    var normalized = String(baseUrl || '/');
    return normalized.replace(/\/?$/, '/') + 'ogloszenia';
}

/**
 * Builds a server-compatible friendly listing URL and leaves every remaining
 * map filter in the query string.
 */
export function buildListingBrowseUrl(baseUrl, filterParams, urlConfig) {
    var params = Object.assign({}, filterParams || {});
    var config = urlConfig || {};
    var path = config.base || fallbackBasePath(baseUrl);
    var category = params.category || '';
    var offerType = params.offer_type || '';
    var categorySegment = config.categories && config.categories[category];

    if (categorySegment) {
        path = String(config.base || fallbackBasePath(baseUrl)).replace(/\/$/, '') + '/' + categorySegment;
        delete params.category;

        var offerSegment = config.offers && config.offers[offerType];
        if (offerSegment) {
            path += '-' + offerSegment;
            delete params.offer_type;
        }
    }

    var search = new URLSearchParams();
    Object.keys(params).forEach(function(key) {
        var value = params[key];
        if (value != null && value !== '') {
            search.set(key, value);
        }
    });

    var query = search.toString();
    return path + (query ? '?' + query : '');
}
